import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  Output,
  ViewChild,
  EventEmitter,
  OnDestroy
} from '@angular/core';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";
import {TableCols, TableOption} from "@app/models";
import {BehaviorSubject, Subscription} from "rxjs";
import {DynamicTableService} from "@app/services/dynamic-table.service";
import { Router} from "@angular/router";

@Component({
    selector: 'dynamic-table',
    templateUrl: './dynamic-table.component.html',
    styleUrls: ['./dynamic-table.component.scss'],
    standalone: false
})
export class DynamicTableComponent implements AfterViewInit, OnInit, OnDestroy {
  private data: any;
  @Input() id: string;
  @Input() selectionRowOption: string;
  @Input() cols: TableCols[];
  @Input() displayedColumns: any[];
  @Input() option: TableOption = {
    pagination: false,
    sort: false,
    selectionable: false,
    optionable: false,
    eventClick: false,
  };
  // Evento para seleccion de items
  @Output() itemsSelectedEvent = new EventEmitter<any[]>();

  // Evento para columna tipo boton
  @Output() columnButtonSelected = new EventEmitter<any>();
  @Output() requestPaginateData = new EventEmitter<any[]>();
  dataSource = new MatTableDataSource<any>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  pageEvent: PageEvent;

  // Historial de elementos
  private itemSelected = [];
  @Input() paginate: any = {
    totalItems: 0,
    page: 1,
    size: 10,
    isFake: false,
    sizeOption: [10, 15, 20, 25]
  };


  totalItems: any;
  // Susbcription de datasource
  subscription: Subscription;

  // Subscription de items checked
  checkItemsSub: Subscription;

  currentUser: any = JSON.parse(localStorage.getItem('currentUser'));

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  constructor(
    private dynamicTableService: DynamicTableService,
    private router: Router,
  ) {
    this.dynamicTableService.refresh([])
  }

  ngOnInit(): void {
    // Se suscribe al datasource de la tabla
    this.subscription = this.dynamicTableService.currentValue
      .subscribe((result: any) => {
        // Valida id del componente
        // (Este previene errores cuando hay mas de este mismo componente en un componente padre)
        if(!result.id && !this.id){
          if(!result.data){
            this.dataSource = new MatTableDataSource<any>(result);
          }else{
            this.dataSource = new MatTableDataSource<any>(result.data);
          }
        }else if(result.id == this.id){
          this.dataSource = new MatTableDataSource<any>(result.data);
          this.paginate.totalItems = result.paginate.totalItems;
          this.dataSource.sort = this.sort;
          if (result.paginate.hasOwnProperty('custom_pagination') && result.paginate.custom_pagination){
            this.dataSource.paginator = this.paginator;
          }

        }
        if(result.reset){
          this.paginator.firstPage();
        }
      });

    // Se suscribe para obtener la opcion de check todos los items o uncheck
    this.checkItemsSub = this.dynamicTableService.checkValue.subscribe((data) => {
      if(data){
        if(data.id == this.id){
          if(data.checked){
            this.checkAll();
          }else{
            this.unchecked(null, true);
          }
        }
      }
    })
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.checkItemsSub.unsubscribe();
  }



  /**
   * Funcion para mostrar columnas anidadas en primer nivel
   * @param column
   */
  addNestedColumns(column){
    column.action.activated = !column.action.activated;

    for(let col of column.action.nestedCol){
      if(column.action.activated && this.cols.map((v)=>{return v.key}).indexOf(col.key) == -1 ){
        this.displayedColumns = [];

        // Re-ordena las columnas
        for(let i = 0; i < this.cols.length;i++){

          if(this.cols[i].action.nestedCol){

            if(this.displayedColumns.indexOf(this.cols[i].id) == -1)
              this.displayedColumns.push(this.cols[i].id);

            this.cols[i].action.nestedCol.map((child) => {
              if( this.displayedColumns.indexOf(child.id) == -1){
                this.displayedColumns.push(child.id);
              }

            });
          }else{
            if(this.displayedColumns.indexOf(this.cols[i].id) == -1)
              this.displayedColumns.push(this.cols[i].id);
          }
        }
        this.cols.push(col);
      }else if (!column.action.activated && this.cols.map((v)=>{return v.key}).indexOf(col.key) != -1 ){
        // Al estar desactivado se eliminan las columnas hijas
        this.displayedColumns.splice(this.displayedColumns.indexOf(col.id), 1);
        this.cols.splice(this.cols.map((v)=>{return v.key}).indexOf(col.key),1);
      }
    }
    this.dynamicTableService.refresh(this.data);
  }

  /**
   * Seleccion de item en row
   * @param element
   * @param event
   */
  selectItem(element, event){
    let node = event.currentTarget.nodeName.toLowerCase();

    // Previene la seleccion en los elementos de input, a y button
    if(node == "input" || node == "a" || node == "button")
      return;

    if(this.option.selectionable){
      // Previene la seleccion en del row cuando tiene activada esta opcion
      if(this.option.checkedBlock != null && (element[this.option.checkedBlock.key] == this.option.checkedBlock.value)){
        return;
      }

      let checkedChange = true;

      // Deselecciona el anterior si esta como opcionable (Opcion seleccionable por row)
      if(this.option.optionable){
        if(this.itemSelected.length > 0){
          if((this.itemSelected[this.itemSelected.length-1].id == element.id) && element.checked){
            this.unchecked( this.itemSelected[this.itemSelected.length-1].id)
            checkedChange = false;
          }else{
            this.unchecked( this.itemSelected[this.itemSelected.length-1].id)
          }
        }
      }


      if(checkedChange){
        element.checked = !element.checked;
        this.itemSelected.push(element);

        if(this.itemSelected.length > 1){
          this.itemSelected.splice(this.itemSelected.length-2,1);
        }

        this.itemsSelectedEvent.emit(element);
      }

    }else{
      return;
    }
  }

  onSelectionRow(item) {
    switch (this.selectionRowOption) {
      case "loans":

      switch (this.currentUser.partner.product_type) {
        case 1:
          this.router.navigate([`loans/${item.id}/mca`]);
          break;
        case 2:
          this.router.navigate([`loans/${item.id}/factoring`]);
          break;
        case 3:
          this.router.navigate([`loans/${item.id}/discount_factoring`]);
          break;
      }

        break;
      case "item":
        this.itemsSelectedEvent.emit(item);
        break;
      default:
        break;
    }
  }

  /**
   * Cambio de valor para campos tipo input
   * @param $event
   * @param element
   * @param key
   */
  onChangeItem($event, element, key){
    element[key] = $event.target.value;
  }

  /**
   * Evento para botones en celda -- columna tipo boton
   * @param element
   * @param buttonType
   */
  buttonSelected(element, buttonType = null){
    element.buttonType = buttonType ? buttonType : null;
    this.columnButtonSelected.emit(element);
  }

  /**
   * Funcion para cambio de pagina en tabla
   * @param event
   */
  onPaginateChange(event: PageEvent){
    let page = event.pageIndex;
    let size = event.pageSize;
    page = page+1;
    this.triggerPaginateDataEvent([page, size])
  }

  /**
   * Emite el evento al componente padre de paginacion
   * @param arr
   */
  triggerPaginateDataEvent(arr){
    this.requestPaginateData.emit(arr);
  }

  /**
   * Deseleccion por item o todos
   * @param id
   * @param all
   */
  unchecked(id, all = false){
    for(let item of this.dataSource.data){
      if(!id){
        item.checked = false;
        this.itemsSelectedEvent.emit(item);
      }else{
        if(item.id == id){
          item.checked = false;
          this.itemsSelectedEvent.emit(item);
          return;
        }
      }
    }
  }

  /**
   * Seleccion de todos
   */
  checkAll(){
    for(let item of this.dataSource.data){
        item.checked = true;
        this.itemsSelectedEvent.emit(item);
    }
  }



}
